// The course library inside a group (28.10.2026, plan PR 4): its activities
// grouped by lesson, and what a trainer reads about each.

const TZ = "Europe/Bucharest";
const NEW_DAYS = 7;

export const LIBRARY_KIND_LABELS = {
  presentation: "Prezentarea",
  support: "Suportul de curs",
  workshop: "Activități în cadrul sesiunii live",
  assignment: "Tema",
  trainer_notes: "Notele pentru trainer",
};
const ORDER = ["presentation", "support", "workshop", "assignment"];

export const isLibrary = (a) => Boolean(a?.template_id);

/** The lessons that have something, in order, each with its activities; the
 *  course-level notes apart. */
export function byLesson(activities, lessons) {
  const lib = (activities || []).filter(isLibrary);
  const names = Object.fromEntries((lessons || []).map((l) => [l.n, l.name]));
  const course = lib.filter((a) => a.theme == null);
  const numbers = [...new Set(lib.filter((a) => a.theme != null).map((a) => a.theme))].sort((x, y) => x - y);
  return {
    course,
    lessons: numbers.map((n) => ({
      n,
      name: names[n] || "",
      items: lib.filter((a) => a.theme === n)
        .sort((x, y) => ORDER.indexOf(x.library_kind) - ORDER.indexOf(y.library_kind) || (x.order || 0) - (y.order || 0)),
    })),
  };
}

function when(iso) {
  return new Intl.DateTimeFormat("ro-RO", { timeZone: TZ, day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })
    .format(new Date(iso));
}

/** For the trainer: whether participants see it, and if not, why or when. */
export function libraryStatus(a, now = new Date()) {
  if (a.library_kind === "trainer_notes") return { label: "doar pentru formatori", tone: "neutral" };
  if (!a.published) return { label: "ascuns", tone: "warn" };
  if (a.visible_from && new Date(a.visible_from) > now) return { label: `apare pe ${when(a.visible_from)}`, tone: "neutral" };
  return { label: "vizibil", tone: "good" };
}

/** "Nou" for a participant: appeared in the last week. */
export function isNew(a, now = new Date()) {
  const at = a.visible_from || a.published_at;
  if (!at) return false;
  const t = new Date(at);
  return t <= now && now - t < NEW_DAYS * 24 * 3600 * 1000;
}
